import { render } from "./MarketingList.vue?vue&type=template&id=6b0effaa"
import script from "./MarketingList.vue?vue&type=script&lang=js"
export * from "./MarketingList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__